export function getTotalInvoiceValuesFromDateRange(statementData: any[], startDate: any, endDate: any): [{ value: number, vat: number, total: number }] {
  const defaultDateTime = (new Date()).getTime();
  const startDateTime = startDate ? new Date(startDate).getTime() : defaultDateTime;
  const endDateTime = endDate ? new Date(endDate).getTime() : defaultDateTime;
  const filteredStatements = statementData
    .filter((item: any) => item.type == 'invoice' && item.status !== 'Cancelled')
    .filter((item: any) => {
      const createdTime = new Date(item.createdAt).getTime();
      return createdTime >= startDateTime && createdTime <=endDateTime;
    });
  const total = filteredStatements.reduce((acc: number, item: any) => acc + item.total, 0);
  const value = filteredStatements.reduce((acc: number, item: any) => acc + item.subtotal, 0);
  const vat = filteredStatements.reduce((acc: number, item: any) => acc + item.total - item.subtotal, 0);
  return [{ value, vat, total }];
}
